<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hideResponsiveTD  ' : 'showResponsiveTD'">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>User Report<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>

          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadUserReports($event)"></button> -->
              <button (click)="loadUserReports(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul> 
          <div class="divider ">
            <hr>
          </div>
          <div class="filterTitle">
            <h5>Filters</h5> 
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
        </div>
        <div class="maincard">
          <div class="filterList">
            <ul>
              <li>
  <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                  (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="country"></p-dropdown>
              </li>
             
              <li>
                <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                  (onChange)="getCities($event)" placeholder="Select State" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="state"></p-dropdown>
              </li>
                <li>
 <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                  (onChange)="loadUserReports(lastTableLazyLoadEvent)" placeholder="Select City" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="cityName"></p-dropdown>
              </li>
               <li>
   <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                  (onChange)="loadUserReports(lastTableLazyLoadEvent)" placeholder="Select Sport" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="sportName"></p-dropdown>
              </li>
              <li>
                 <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                  (onChange)="loadUserReports(lastTableLazyLoadEvent)" placeholder="Select Academy" optionLabel="name"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="academyId"></p-dropdown>
              </li>
            
            </ul>
          </div> 

        </div> 
        <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registered Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userReportsData?.summary?.totalRegisteredUsers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registered Players</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userReportsData?.summary?.totalRegisteredPlayers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registered Coaches</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userReportsData?.summary?.totalRegisteredCoaches }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registered Pro Players</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userReportsData?.summary?.totalRegisteredProPlayers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Number of Male Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userReportsData?.summary?.numberOfMaleUsers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Number of Female Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{userReportsData?.summary?.numberOfFemaleUsers}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Number of Users Above 18</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{userReportsData?.summary?.numberOfUsersAbove18}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Number of Users Under 18</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{userReportsData?.summary?.numberOfUsersUnder18}}</h3>
                  </div>
              </div>
            </li>
          </ul>
        </div>
          <!-- <table>
            <thead>
                <tr>
                    <th>Total Registered Users</th>
                    <th>Total Registered Players</th>
                    <th>Total Registered Coaches</th>
                    <th>Total Registered Pro Players</th>
                    <th>Number of Male Users</th>
                    <th>Number of Female Users</th>
                    <th>Number of Users Above 18</th>
                    <th>Number of Users Under 18</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ userReportsData?.summary?.totalRegisteredUsers }}</td>
                    <td>{{ userReportsData?.summary?.totalRegisteredPlayers }}</td>
                    <td>{{ userReportsData?.summary?.totalRegisteredCoaches }}</td>
                    <td>{{ userReportsData?.summary?.totalRegisteredProPlayers }}</td>
                    <td>{{ userReportsData?.summary?.numberOfMaleUsers }}</td>
                    <td>{{ userReportsData?.summary?.numberOfFemaleUsers }}</td>
                    <td>{{ userReportsData?.summary?.numberOfUsersAbove18 }}</td>
                    <td>{{ userReportsData?.summary?.numberOfUsersUnder18 }}</td>
                </tr>
            </tbody>
          </table> -->
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="userReportsData?.data" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadUserReports($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="email" class="emailTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> EmailID <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="created_at"></p-sortIcon>
                    </div>
                  </th>
                  <th class="genderTD" pSortableColumn="gender">
                    <div class="p-d-flex p-jc-between p-ai-center"> Gender <p-sortIcon
                        field="transferAmount"></p-sortIcon>
                    </div>
                  </th>
                  <!-- <th class="" pSortableColumn="tds"><div class="p-d-flex p-jc-between p-ai-center"> TDS <p-sortIcon field="tds"></p-sortIcon></div></th> -->
                  <!-- <th class="CommissionTD" pSortableColumn="commission">
                      <div class="p-d-flex p-jc-between p-ai-center"> Commission <p-sortIcon field="commission"></p-sortIcon>
                      </div>
                    </th> -->
                  <th class="cityTD" pSortableColumn="city">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon
                        field="totalCreditedAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="stateTD" pSortableColumn="state"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="bankName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="registrationDate">
                    <div class="p-d-flex p-jc-between p-ai-center"> Registration Date <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td"  style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th [ngSwitch]="academyName" pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]=" dt.filters['academyName'] ? dt.filters['academyName'].value : ''" /> -->
                  </th>

                  <th [ngSwitch]="userName" class="emailTD " style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="created_at" class="userNameTD">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="transferAmount" class="genderTD " style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains') "
                      [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="totalCreditedAmount" class="cityTD "
                    style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'totalCreditedAmount', 'contains') "
                      [value]=" dt.filters['totalCreditedAmount'] ? dt.filters['totalCreditedAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="bankName " class="stateTD " style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'bankName', 'contains')"
                      [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="registrationDateTD">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-userReportsData>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="{{userReportsData?.mobileNumber}}" tooltipPosition="bottom">
                      {{userReportsData?.mobileNumber}}
                    </div>
                  </td>

                  <td class="emailTD">
                    {{userReportsData?.email}}
                  </td>
                  <td class="userNameTD">
                    {{ userReportsData?.username }}
                  </td>
                  <td class="genderTD">
                    {{ userReportsData?.gender }}
                  </td>
                  <td class="cityTD">
                    {{ userReportsData?.city }}
                  </td>
                  <td class="stateTD">
                    {{ userReportsData?.state }}
                  </td>
                  <td class="registrationDateTD">
                    {{ userReportsData?.registrationDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">User Report list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
